import { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import AIAssistantModal from './AIAssistantModal';

export default function AIInsightBubble() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.8 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="fixed bottom-8 right-8 z-30"
      >
        <motion.button
          onClick={() => setIsModalOpen(true)}
          animate={{
            y: [0, -10, 0],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="bg-gradient-to-r from-bz-blue to-blue-500 text-white rounded-2xl shadow-2xl p-4 max-w-sm hover:shadow-blue-500/50 hover:scale-105 transition-transform cursor-pointer"
        >
          <div className="flex items-start gap-3">
            <motion.div
              animate={{
                rotate: [0, 360],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "linear"
              }}
            >
              <Sparkles className="w-6 h-6 flex-shrink-0" />
            </motion.div>
            <div className="text-left">
              <h4 className="font-semibold mb-1">AI Assistant</h4>
              <p className="text-sm text-white/90">
                Pose-moi tes questions • Je te guide!
              </p>
            </div>
          </div>
        </motion.button>
      </motion.div>

      <AIAssistantModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}



